import Spinner from 'src/javascripts/components/utilities/Spinner';
import * as filestack from 'filestack-js';
import * as fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';

export default class PortfoliosModelsImportsNew {

  constructor() {}

  render() {

    // Upload file
    // Set environment and account id for AWS path vars
    $('.asset-filepicker').each(function(i, elem) {
      let fileInput     = $(elem);
      let env           = fileInput.data("env");
      let accountUrl       = fileInput.data("account-url");
      var progressBar   = $("<div class='bar'></div>");
      var barContainer  = $("<div class='progress'></div>").append(progressBar);
      $('#fileUploadProgress').append(barContainer);
      fileInput.fileupload({
        fileInput:        fileInput,
        url:              fileInput.data('url'),
        type:             'POST',
        autoUpload:       true,
        formData:         fileInput.data('form-data'),
        paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
        dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
        replaceFileInput: false,
        progressall: function (e, data) {
          var progress = parseInt(data.loaded / data.total * 100, 10);
          progressBar.css('width', progress + '%')
        },
        start: function (e) {
          progressBar.
            css('background', '#8c81d1').
            css('display', 'block').
            css('width', '0%').
            text("Loading...");
        },
        done: function(e, data) {
          progressBar.text("Uploading done");

          // extract key from response
          let key = $(data.jqXHR.responseXML).find("Key").text();
          let accountUrl = $('.asset-filepicker').attr('data-account-url');
          let clientId = $('.asset-filepicker').attr('data-client-id');
          let modelId = $('.asset-filepicker').attr('data-model-id');
          let portfolioId = $('.asset-filepicker').attr('data-portfolio-id');
          let assetsScope = $('.asset-filepicker').attr('data-assets-scope');
          let params = {};
          if (typeof portfolioId !== 'undefined') {params['portfolio_id'] = portfolioId;}
          if (typeof assetsScope !== 'undefined') {params['assets_scope'] = assetsScope;}

          // Set spinner so user knows in progress
          $('.filepicker-container .filepicker-label').addClass('opaque');
          Spinner($('.filepicker-container'));

          // Check whether uploaded file is csv or xls
          if (key.slice(-4) !== '.csv') {
            let url = '/' + accountUrl + '/portfolios/models/' + modelId + '/imports/new?' + $.param(params);
            Turbo.visit(url + '&notice=Only .csv files allowed');

          } else {
            let url = '/' + accountUrl + '/portfolios/models/' + modelId + '/imports?' + $.param(params);
            let formData = {}
            formData['file'] = {}
            formData['file']['key'] = key;

            // Update local attribute
            return $.ajax({
              type: 'POST',
              url: url,
              dataType: "application/json",
              data: formData,
              complete(result) { 
                let url = window.location.href.split('?')[0];
                let importId = JSON.parse(result.responseText).import_id;
                if (result.status === 200) {
                  params['notice'] = 'Successfully uploaded your file. Map your assets below';
                  url = '/' + accountUrl + '/portfolios/models/' + modelId + '/imports/' + importId + '/map?' + $.param(params);
                } else {
                  params['notice'] = 'There was a problem, please contact us for support';
                  url = '/' + accountUrl + '/portfolios/models/' + modelId + '/imports?' + $.param(params);
                }
                return Turbo.visit(url);
              },
            });

          }

        },
        fail: function(e, data) {
          progressBar.
            css("background", "red").
            text("Failed");
        }
      });
    });


  }

}